$(document).ready( function() {

    $(".partner-container").each(function () {

        var parentID = $(this).attr('id');
        var visibleCount = $(this).data("count");

        var containerHeight = 0;
        var imgElements = $(this).find(".partner img")
        imgElements.each(function () {
            if(containerHeight < $(this).outerHeight()) {
                containerHeight = $(this).outerHeight();
            }
        })

        $(this).find("> div").css('min-height', containerHeight+'px');

        if(imgElements.length > visibleCount) {
            changePartner(parentID, visibleCount, 0)
        }

    })

    function changePartner(parentID, visibleCount, offset) {
        if(offset >= visibleCount) {
            offset = 0;
        }

        var partner = $('#'+parentID).find(".partner");
        var tmpPartner = $(partner[offset]);

        var hiddenPartner = partner.filter('.d-none')

        var random = Math.floor(Math.random()* hiddenPartner.length);
        var randomPartner = hiddenPartner.eq(random);

        randomPartner.removeClass("d-none");

        tmpPartner.delay( 700 ).fadeOut(800, function() {
            var tmpPartnerHTML = tmpPartner.parent().html();
            tmpPartner.parent().html(randomPartner.parent().html())

            randomPartner.parent().html(tmpPartnerHTML)

            var randomPartnerID = randomPartner.attr("id")
            var tmpPartnerId = tmpPartner.attr("id")

            $("#"+tmpPartnerId).addClass("d-none");

            $("#"+randomPartnerID).fadeIn(800, function () {
                changePartner(parentID, visibleCount, ++offset)
            })
        });

    }

});